export enum PaymentMethod {
    CASH = 'CASH',
    PAY2SELL = 'PAY2SELL',
    PAY_TODAY = 'PAY_TODAY',
    E_WALLET = 'E_WALLET',
    SPEED_POINT = 'SPEED_POINT'
}
